import { RouterModule } from "@angular/router";

import { HomeComponent } from "./home.component";
import { AuthenticatedGuard, PrivacyGuard } from "../shared/index";
import { CallEventsComponent } from "./call-events/call-events.component";
import { ResidentsComponent } from "./residents/residents.component";

import { canActivateForAppInError } from "../something-went-wrong/something-went-wrong.guard";
import { HomeGuard } from "./home.guard";
import { PermissionsGuard } from "app/shared/guards/permissions.guard";
import { BriefingHistoryComponent, UserBriefingComponent } from "app/briefing";
import { SyncActionsOverviewComponent } from "../sync-actions/containers/sync-actions-overview/sync-actions-overview.component";
import { AnnouncementsComponent } from "./announcements/announcements.component";
import { IncidentListComponent } from "app/medication/found-medication-incident/containers/incident-list/incident-list.component";
import { FoundMedicationIncidentModule } from "app/medication/found-medication-incident/found-medication-incident.module";

export const routing = RouterModule.forChild([
	{
		path: "",
		canActivate: [canActivateForAppInError, AuthenticatedGuard],
		children: [
			{
				path: "",
				canActivate: [PrivacyGuard],
				children: [
					{
						path: "",
						redirectTo: "home",
						pathMatch: "full",
					},
					{
						path: "home",
						component: HomeComponent,
						children: [
							{ path: "", pathMatch: "full", children: [], canActivate: [HomeGuard] },
							{ path: "residents", component: ResidentsComponent },
							{ path: "alarms", component: CallEventsComponent },
							{
								path: "medication",
								loadChildren: () =>
									import("app/medication/medication-overview/medication-overview.module").then(
										(m) => m.MedicationOverviewModule,
									),
							},
							{
								path: "briefing-history",
								component: BriefingHistoryComponent,
							},
							{
								path: "announcements",
								component: AnnouncementsComponent,
							},
							{
								path: "dar",
								loadChildren: () => import("app/dar/dar.routes").then((m) => m.darRoutes),
							},
							{
								path: "found-medication-incident-overview",
								component: IncidentListComponent,
							},
							{
								path: "communication",
								canActivate: [PermissionsGuard],
								data: {
									permissions: ["MEDAPP.INTERNAL_COMMUNICATION"],
									redirect: {
										url: "/home",
										exact: true,
									},
								},
								loadChildren: () => import("@intocare-medapp/features/communication"),
							},
						],
					},
					{
						path: "found-medication-incident",
						loadChildren: () => FoundMedicationIncidentModule,
					},
					{
						path: "filters",
						loadChildren: () => import("app/filter/filter.module").then((m) => m.FilterModule),
					},
					{
						path: "user-briefing",
						canActivate: [PermissionsGuard],
						data: {
							features: ["Briefing"],
							redirect: {
								url: "/home",
								exact: true,
							},
						},
						component: UserBriefingComponent,
					},
					{
						path: "sync-actions",
						canActivate: [PermissionsGuard],
						data: {
							redirect: {
								url: "/home",
								exact: true,
							},
						},
						component: SyncActionsOverviewComponent,
					},
				],
			},
		],
	},
]);
